import request from '@/utils/request'

// 获取投放组列表
export function getReleaseGroupList(params = {}) {
  return request({
    url: '/release_report/release_group',
    method: 'get',
    params
  })
}

// 添加投放组
export function addReleaseGroup(data = {}) {
  return request({
    url: '/release_report/release_group',
    method: 'post',
    data
  })
}
// 书籍
export function updateReleaseBookType(params = {}) {
  return request({
    url: `/release_report/book_type`,
    method: 'get',
    params
  })
}

// 更新投放组
export function updateReleaseGroup(data = {}) {
  return request({
    url: `/release_report/release_group/${data.id}`,
    method: 'PUT',
    data
  })
}

// 获取投放组投手列表
export function getListOfPitchersInTheLaunchGroup(params = {}) {
  return request({
    url: `/release_report/release_group_user`,
    method: 'get',
    params
  })
}

// 添加投放组投手
export function addOfPitchersInTheLaunchGroup(data = {}) {
  return request({
    url: `/release_report/release_group_user_add`,
    method: 'post',
    data
  })
}

// 删除投放组投手
export function deleteOfPitchersInTheLaunchGroup(data = {}) {
  return request({
    url: `/release_report/release_group_user_del`,
    method: 'DELETE',
    data
  })
}

// 获取运营组列表
export function getOperationGroupList(params = {}) {
  return request({
    url: `/release_report/operation_group`,
    method: 'GET',
    params
  })
}

// 添加运营组
export function addOperationGroup(data = {}) {
  return request({
    url: `/release_report/operation_group`,
    method: 'post',
    data
  })
}

// 修改运营组
export function modifyOperationGroup(data = {}) {
  return request({
    url: `/release_report/operation_group/${data.id}`,
    method: 'PUT',
    data
  })
}

// 获取运营者列表
export function getOperatorList(params = {}) {
  return request({
    url: `/release_report/operation_group_user`,
    method: 'get',
    params
  })
}

// 添加运营者
export function addOperator(data = {}) {
  return request({
    url: `/release_report/operation_group_user_add`,
    method: 'post',
    data
  })
}

// 删除运营者
export function deleteOperator(data = {}) {
  return request({
    url: `/release_report/operation_group_user_del`,
    method: 'DELETE',
    data
  })
}

// 获取小说列表
export function getFictionList(params = {}) {
  return request({
    url: `/release_report/novel_list`,
    method: 'get',
    params
  })
}

// 获取书籍归属列表
export function getBookOwnershipList(params = {}) {
  return request({
    url: `/release_report/belong_list`,
    method: 'get',
    params
  })
}

// 添加书籍归属
export function addBookOwnership(data = {}) {
  return request({
    url: `/release_report/add_belong_book`,
    method: 'post',
    data
  })
}

// 修改书籍归属
export function modifyBookOwnership(data = {}) {
  return request({
    url: `/release_report/update_belong_book`,
    method: 'PUT',
    data
  })
}
// 删除书籍归属
export function deleteBooks(id) {
  return request({
    url: `/release_report/del_belong_book?id=${id}`,
    method: 'delete'
  })
}

// 获取书名列表
export function getTitleList(params = {}) {
  return request({
    url: `/release_report/book_alias_list`,
    method: 'get',
    params
  })
}

// 小说绑定书籍归属
export function novelsBoundToBooks(data = {}) {
  return request({
    url: `/release_report/add_alias`,
    method: 'post',
    data
  })
}

// 删除小说绑定书籍归属
export function deleteNovelsBoundToBooks(data = {}) {
  return request({
    url: `/release_report/del_alias`,
    method: 'DELETE',
    data
  })
}

// 投放位置列表
export function dropLocationList(params = {}) {
  return request({
    url: `/release_report/positions`,
    method: 'get',
    params
  })
}

// 添加投放位置
export function addDropLocationList(data = {}) {
  return request({
    url: `/release_report/positions`,
    method: 'post',
    data
  })
}

// 修改投放位置
export function modifyDropLocationList(data = {}) {
  return request({
    url: `/release_report/positions/${data.id}`,
    method: 'put',
    data
  })
}

// 获取绑定关系列表
export function getBindingRelationList(params = {}) {
  return request({
    url: `/release_report/bind_wechat`,
    method: 'get',
    params
  })
}

// 获取公众号列表
export function getTheListOfOfficialAccount(params = {}) {
  return request({
    url: `/release_report/wechat_list`,
    method: 'get',
    params
  })
}

// 获取广告主
export function getAdvertiser(params = {}) {
  return request({
    url: `/release_report/advertiser_list`,
    method: 'get',
    params
  })
}

// 添加投放关系
export function addReleaseRelationship(data = {}) {
  return request({
    url: `/release_report/bind_wechat`,
    method: 'post',
    data
  })
}

// 修改投放关系
export function modifyReleaseRelationship(id, data = {}) {
  return request({
    url: `/release_report/bind_wechat/${id}`,
    method: 'put',
    data
  })
}

// 删除投放关系
export function deleteReleaseRelationship(id) {
  return request({
    url: `/release_report/bind_wechat/${id}`,
    method: 'DELETE'
  })
}

// 获取报表列表
export function getReportList(params = {}) {
  return request({
    url: `/release_report/bind_wechat_report`,
    method: 'get',
    params
  })
}

// 导出报表
export function exportReport(data = {}) {
  return request({
    url: `/release_report/export_bind_data`,
    method: 'post',
    data
  })
}
// 广告主消耗导出报表
export function exportAdq(data = {}) {
  return request({
    url: `/release_report/export_bind_data_advertiser`,
    method: 'post',
    data
  })
}
// 修改消耗
export function modifyConsumption(data = {}) {
  return request({
    url: `/release_report/edit_consume`,
    method: 'PUT',
    data
  })
}

// 修改RIO标准
export function modifyStandard(data = {}) {
  return request({
    url: `/release_report/edit_roi_standard`,
    method: 'PUT',
    data
  })
}
// 获取总计报表列表
export function getTotalReportList(params = {}) {
  return request({
    url: `/release_report/bind_wechat_total_report`,
    method: 'get',
    params
  })
}

// 导出总计报表
export function exportTotalReport(data = {}) {
  return request({
    url: `/release_report/export_bind_total_data`,
    method: 'POST',
    data
  })
}

// 获取平台
export function getPlatform(params = {}) {
  return request({
    url: `/common/specific_platform_list`,
    method: 'get',
    params
  })
}

// T图列表
export function tFigureList(params = {}) {
  return request({
    url: `/release_report/bind_wechat_t_report`,
    method: 'get',
    params
  })
}

// 导出T图列表
export function exportTFigureList(data = {}) {
  return request({
    url: `/release_report/export_bind_t_data`,
    method: 'post',
    data
  })
}

// 更新
export function toUpdate(params = {}) {
  return request({
    url: `/release_report/bind_wechat_t_report_update`,
    method: 'get',
    params
  })
}

export function launchTeamLeader(params = {}) {
  return request({
    url: `/release_report/release_group_leader`,
    method: 'get',
    params
  })
}

// 删除投放组
export function deleteMy(id) {
  return request({
    url: `/release_report/release_group/${id}`,
    method: 'delete'
  })
}

// 删除运营组
export function deleteOperationGroup(id) {
  return request({
    url: `/release_report/operation_group/${id}`,
    method: 'delete'
  })
}
// 阈值配置列表
export function thresholdlist(params = {}) {
  return request({
    url: `/release_report/bind_threshold_configs`,
    method: 'get',
    params
  })
}
// 阈值配置添加
export function bindthresholdconfigs(data = {}) {
  return request({
    url: `/release_report/bind_threshold_configs`,
    method: 'POST',
    data
  })
}
// 阈值配置修改
export function editbindthresholdconfigs(id, data = {}) {
  return request({
    url: `/release_report/bind_threshold_configs/${id}`,
    method: 'put',
    data
  })
}
// 阈值配置删除
export function deletebindthresholdconfigs(id) {
  return request({
    url: `/release_report/bind_threshold_configs/${id}`,
    method: 'delete'
  })
}
// 飞书用户列表
export function feishuuserlist(params = {}) {
  return request({
    url: `/release_report/feishu_user`,
    method: 'get',
    params
  })
}
// 分组导出
export function bindwechatreportnew(params = {}) {
  return request({
    url: `/release_report/bind_wechat_report_new`,
    method: 'get',
    params
  })
}
// 用户QQ关联的广告组
export function adgroupsList(params = {}) {
  return request({
    url: `/ad_management/account/adgroups/index`,
    method: 'get',
    params
  })
}
// 查找用户自建的资产
export function account_asset_info(params = {}) {
  return request({
    url: `/ad_management/account/adgroups/account_asset_info`,
    method: 'get',
    params
  })
}
// 批量更新用户QQ下的广告组
export function batch_update_adgroup_account(data = {}) {
  return request({
    url: `/ad_management/account/adgroups/batch_update_adgroup_account`,
    method: 'POST',
    data
  })
}
// 查找广告组修改记录
export function select_adgroups_record(params = {}) {
  return request({
    url: `/ad_management/account/adgroups/select_adgroups_record`,
    method: 'get',
    params
  })
}
// 获取总计报表列表V2
export function getTotalReportListV2(params = {}) {
  return request({
    url: `/release_report/bind_wechat_total_report_v2`,
    method: 'get',
    params
  })
}

// 违规单据查询
export function adManagementList(params = {}) {
  return request({
    url: `/ad_management/account_punish/list`,
    method: 'get',
    params
  })
}

// 投手更换投放组
export function replaceReleaseGroup(data = {}) {
  return request({
    url: `/release_report/replace_release_group`,
    method: 'POST',
    data
  })
}
// 总计报表列表
export function bindwechattotallist(params = {}) {
  return request({
    url: `/release_report_v2/bind_wechat_total_report`,
    method: 'get',
    params
  })
}
// 总计报表公众号关注数据
export function releasereportv2followlist(params = {}) {
  return request({
    url: `/release_report_v2/follow_list`,
    method: 'get',
    params
  })
}
// 总计报表图形数据
export function releasereportv2graphicsdata(params = {}) {
  return request({
    url: `/release_report_v2/graphics_data`,
    method: 'get',
    params
  })
}
// 手动提交订单文件
export function releasehanduploadorder(data = {}) {
  return request({
    url: `/release_report_v2/hand_upload_order`,
    method: 'POST',
    data
  })
}
// 投放报表查询接口
export function userdailyreportbindwechatlist(params = {}) {
  return request({
    url: `/release_report_v2/bind_wechat_report`,
    method: 'get',
    params
  })
}
// 日报表的
export function preditdayv2(params = {}) {
  return request({
    url: `/report_form/predit/day_v2`,
    method: 'get',
    params
  })
}
// 日报表图形
export function preditdaygraphics(params = {}) {
  return request({
    url: `/report_form/predit/day_graphics`,
    method: 'get',
    params
  })
}
// 日交易分析
export function preditdaygraphicslist(params = {}) {
  return request({
    url: `/report_form/predit/day_graphics_list`,
    method: 'get',
    params
  })
}
// 月列表
export function preditmonthv2(params = {}) {
  return request({
    url: `/report_form/predit/month_v2`,
    method: 'get',
    params
  })
}
// 月列表图形
export function preditmonthgraphics(params = {}) {
  return request({
    url: `/report_form/predit/month_graphics`,
    method: 'get',
    params
  })
}
// 年列表
export function predityearv2(params = {}) {
  return request({
    url: `/report_form/predit/year_v2`,
    method: 'get',
    params
  })
}
// 年列表图形
export function predityeargraphics(params = {}) {
  return request({
    url: `/report_form/predit/year_graphics`,
    method: 'get',
    params
  })
}
// IAA 模块-总计报表
export function iiianewlisttotalV2(params = {}) {
  return request({
    url: `/mini_program_report/totalV2`,
    method: 'get',
    params
  })
}
// IAA 模块-总计报表图形
export function iiianewlisttotalGraphics(params = {}) {
  return request({
    url: `/mini_program_report/totalGraphics`,
    method: 'get',
    params
  })
}
// IAA 模块-总计报表小程序注册数
export function iiianewechat(params = {}) {
  return request({
    url: `/mini_program_report/regList`,
    method: 'get',
    params
  })
}
// IAA 模块-报表列表
export function iiiabaolist(params = {}) {
  return request({
    url: `/mini_program_report/listV2`,
    method: 'get',
    params
  })
}
// 新导出报表
export function nexportReport(data = {}) {
  return request({
    url: `/release_report_v2/export_bind_data`,
    method: 'post',
    data
  })
}
// 新导出总计报表
export function exportTotalReportnew(data = {}) {
  return request({
    url: `/release_report_v2/export_bind_total_data`,
    method: 'POST',
    data
  })
}
// 广告主消耗导出报表
export function exportadvertiserdata(data = {}) {
  return request({
    url: `/release_report_v2/export_advertiser_data`,
    method: 'post',
    data
  })
}
// 分组导出 新
export function exportdifferentdimensionreport(data = {}) {
  return request({
    url: `/release_report_v2/export_different_dimension`,
    method: 'post',
    data
  })
}
// 关停广告
export function stopAdvertisers(data = {}) {
  return request({
    url: `/release_report/stop_advertisers`,
    method: 'post',
    data
  })
}
// 处罚指标
export function measurementIndicator(params = {}) {
  return request({
    url: `/ad_management/account_punish/measurementIndicator`,
    method: 'get',
    timeout: 30 * 1000,
    params
  })
}
// 处罚详情
export function measurementDetail(params = {}) {
  return request({
    url: `/ad_management/account_punish/measurementDetail`,
    method: 'get',
    timeout: 30 * 1000,
    params
  })
}
